import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';


const Body = ({ taxSummary, beginDate, endDate }) => {
    return (
        <div id="taxSummaryReport">
            {
                taxSummary && taxSummary.list && taxSummary.list.length <= 0 ?
                    //If there's NO DATA to display
                    <NoDataMsg />
                    :
                    //If there's DATA
                    taxSummary && taxSummary.list && taxSummary.list.length > 0 &&
                    <div>

                        {/* TRANSACTIONS */}
                        <div className="row m-0">
                            <div className="text-center list_header">
                                {beginDate ?
                                    <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                        {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                    : ""}
                            </div>
                        </div>
                        <div className="row m-0 mb-2 center_xs col-4-p-0 col-4-em-0" >
                            <div className="col-lg-12 title_summary">
                                <h3 className="m-0">SUMMARY</h3>
                            </div>{/* row - Date */}
                            <div className="col-lg-12 mb-1">
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <label>Total Tax</label>
                                    <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(taxSummary.totalTax)}</h3>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <label>Total GST</label>
                                    <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(taxSummary.totalGST)}</h3>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <label>Total PST</label>
                                    <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(taxSummary.totalPST)}</h3>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <label>Total PST_Vape</label>
                                    <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(taxSummary.totalPST_Vape)}</h3>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <label>Total HST</label>
                                    <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(taxSummary.totalHST)}</h3>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <label>Total PSK_SK</label>
                                    <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(taxSummary.totalPST_SK)}</h3>
                                </div>
                            </div>
                        </div>

                        <div >
                            {
                                taxSummary.list.map((item, index) => {
                                    return (
                                        <div className="row m-0 mb-2 center_xs col-4-p-0 col-4-em-0" key={index}>
                                            <div className="col-lg-12 title_th">
                                                <h3 className="m-0">{moment(item.date).format('MMMM Do, YYYY')}</h3>
                                            </div>{/* row - Date */}

                                            <div className="col-lg-12 mb-1">
                                                <div className="col-lg-12 mb-1">
                                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                        <label>Total Tax</label>
                                                        <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(item.totalTax)}</h3>
                                                    </div>
                                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                        <label>Total GST</label>
                                                        <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(item.totalGst)}</h3>
                                                    </div>
                                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                        <label>Total PST</label>
                                                        <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(item.totalPst)}</h3>
                                                    </div>
                                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                        <label>Total PST_Vape</label>
                                                        <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(item.totalPst_Vape)}</h3>
                                                    </div>
                                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                        <label>Total HST</label>
                                                        <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(item.totalHst)}</h3>
                                                    </div>
                                                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                        <label>Total PSK_SK</label>
                                                        <h3 className="m-0 purple-text size_1-3vmax">{getDollarFormat(item.totalPst_SK)}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                        );
                                })
                            }

                    </div>
                    </div>
            }
        </div >
    );
};

export default Body;